import {EditorState, TextSelection, Transaction} from "prosemirror-state";
import {deleteTable, removeColumn, TableMap} from "prosemirror-tables";
import {EditorView} from "prosemirror-view";

import type {TableContextMenuParams} from "../../../../ui/elements/context-menu/editor/TableToolbar/openTableContextMenu";
import {getNearestCellPos} from "../../../utils/table/getNearestCellPos";
import {isPosInTable} from "../../../utils/table/isPosInTable";
import {getInTableRect} from "../../../utils/table/getInTableRect";

export const deleteColumn = (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, params?: TableContextMenuParams): boolean => {
    let targetPos = state.selection.$from.pos;
    if (params?.clickPos) {
        targetPos = params.clickPos;
    }
    const $pos = getNearestCellPos(state.doc.resolve(targetPos));
    if (!$pos || !isPosInTable($pos)) {
        return false;
    }

    if (dispatch) {
        const rect = getInTableRect($pos);
        const tr = state.tr;

        if (rect.left === 0 && rect.right === rect.map.width) {
            return deleteTable(state, dispatch);
        }

        for (let i = rect.right - 1; i !== rect.left; i--) {
            rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1)! : tr.doc;
            rect.map = rect.table && rect.table.type.name === "table" ? rect.table.attrs.map : undefined;
        }

        for (let i = rect.right - 1; ; i--) {
            removeColumn(tr, rect, i);
            if (i === rect.left) {
                break;
            }
            const table = rect.tableStart
                ? tr.doc.nodeAt(rect.tableStart - 1)
                : tr.doc;
            if (!table) {
                throw RangeError('No table found');
            }
            rect.table = table;
            rect.map = TableMap.get(table);
        }

        const columnToDelete = rect.left < rect.map!.width - 1
            ? rect.left
            : rect.left - 1;
        const pos = rect.map!.positionAt(0, columnToDelete, rect.table!);

        tr.setSelection(TextSelection.near(tr.doc.resolve(rect.tableStart + pos)));
        dispatch(tr);
    }

    return true;
}